module.exports = __webpack_public_path__ + "static/img/chevron_bold_right.244ba19c.svg";